import React from 'react';
import {
  Edit,
  FormTab,
  TabbedForm,
  CardActions,
  ListButton,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import ShowButton from './ShowButton';
import SaveOnlyToolbar from '../SaveOnlyToolbar';

import { validateOffer } from '../../validators';

const Title = ({ record }) => (
  <span>Offer: <strong>{record.name}</strong></span>
);


const Actions = ({ basePath, data, path }) => (
  <CardActions>
    <ShowButton basePath={basePath} record={data} path={path} />
    <ListButton basePath={basePath} />
  </CardActions>
);

const solicitedAdmin = choice => `${choice.email} (${choice.role})`;

export default props => (
  <Edit
    {...props}
    title={<Title />}
    actions={<Actions path={props.location.pathname} />}
    undoable={false}
  >
    <TabbedForm toolbar={<SaveOnlyToolbar />} validate={validateOffer}>
      <FormTab label="Solicitation">
        <ReferenceInput
          source="solicitedBy"
          reference="users"
          label="SolicitedBy"
          basePath="users"
          filter={{ role: '_not_null_' }}
        >
          <SelectInput
            optionText={solicitedAdmin}
          />
        </ReferenceInput>
      </FormTab>
    </TabbedForm>
  </Edit>
);




// WEBPACK FOOTER //
// ./src/components/OfferOrder/Edit.js